export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const REGISTER = 'register';
export const UPDATE_USER = 'updateUser';
export const PROFILE_ADD = 'addProfile';
export const PROFILE_DELETE = 'deleteProfile';
//
export const UPLOAD_CV_FORM = 'uploadCvForm';
export const SEND_SIMPLE_CONTACT_FORM = 'sendSimpleContactForm';
export const JOBS_GET_ALL = 'jobsGetAll';
//
export const EVENT_CREATE_EVENT_APPOINTMENT = 'createEventAppointment';
//
export const SEND_REPAIR_FORM = 'repairForm';
export const LUHN_CHECK = 'luhnCheck';
